import { api } from '../../../shared/api/client';

export const getPayIns = (params = {}) => api.post('pay-in/getPayIns', params);
export const getTop = (params = {}) => api.post('pay-in/getTop', params);

export const adminGetPayIns = (params = {}) => api.post('admin/pay-in/getPayIns', params);
export const getHiddenPayIns = (params = {}) => api.post('admin/pay-in/getHiddenPayIns', params);
export const unhidePayIn = (params = {}) => api.post('admin/pay-in/unhidePayIn', params);
export const update = (data = {}) => api.post('admin/pay-in/update', data);
export const callback = (uuid = {}) => api.get('admin/pay-in/callback', { params: { uuid } });
export const getListTransaction = (uuid = {}) => api.get('admin/pay-in/getListTransaction', { params: { uuid } });
export const getTransaction = (uuid = {}) => api.get('admin/pay-in/getTransaction', { params: { uuid } });

export const exportFile = async (params, filename) => {
    const result = await api.download('admin/pay-in/exportFile', { params, filename });
    if (result instanceof Blob) {
        return { success: true };
    }
    return result;
};
